<app-header [pageTitle]="'College Type-Year Mapping'" [showCollegeLogo]="true"></app-header>

<ion-content>
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="12" size-md="11" size-lg="10">

        <!-- Warning Notice -->
        <div class="warning-section clay-card">
          <div class="clay-card-body">
            <div class="warning-content">
              <i class="fas fa-exclamation-triangle"></i>
              <p>College type once assigned to a year cannot be changed.</p>
            </div>
          </div>
        </div>

        <!-- Add New Mapping Section -->
        <div class="add-mapping-section clay-card">
          <div class="clay-card-body">
            <div class="section-header">
              <i class="fas fa-calendar-plus"></i>
              <span>Add New Year Mapping</span>
            </div>

            <div class="mapping-form">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">
                    <i class="fas fa-calendar-alt"></i> From Year
                  </label>
                  <select
                    [(ngModel)]="selectedYearFrom"
                    (change)="handleFromYearChange()"
                    class="modern-select">
                    <option value="" selected disabled>Select From Year</option>
                    @for (fromYearOption of fromYearOptions; track fromYearOption) {
                      <option value="{{fromYearOption}}">{{fromYearOption}}</option>
                    }
                  </select>
                </div>

                <div class="year-flow-arrow">
                  <i class="fas fa-arrow-right"></i>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="fas fa-calendar-check"></i> To Year
                  </label>
                  <div class="year-badge-display">
                    {{selectedYearTo || 'Auto-calculated'}}
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group college-type-group">
                  <label class="form-label">
                    <i class="fas fa-university"></i> College Type
                  </label>
                  <select
                    [(ngModel)]="selectedCollegeType"
                    class="modern-select">
                    <option value="" selected disabled>Select College Type</option>
                    @for (collegeType of metadata.collegeTypeList; track collegeType) {
                      <option value="{{collegeType}}">{{collegeType}}</option>
                    }
                  </select>
                </div>

                <button
                  class="add-mapping-btn"
                  [disabled]="!selectedYearFrom || !selectedCollegeType"
                  (click)="confirmationAlertForMappingAddition()">
                  <i class="fas fa-plus-circle"></i> Add Mapping
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!yearToCollegeMapping || yearToCollegeMapping.length === 0">
          <i class="fas fa-calendar-times fa-3x"></i>
          <h5>No Year Mappings Yet</h5>
          <p>Add your first college type-year mapping using the form above.</p>
        </div>

        <!-- Mappings List -->
        <div class="mappings-list" *ngIf="yearToCollegeMapping && yearToCollegeMapping.length > 0">
          @for (mapping of yearToCollegeMapping; track mapping; let i = $index) {
            <div class="mapping-card clay-card">
              <div class="clay-card-body">
                <div class="mapping-timeline">
                  <div class="year-from">
                    <span class="year-label">From</span>
                    <span class="year-value">{{mapping.yearFrom}}</span>
                  </div>

                  <div class="timeline-connector">
                    <div class="connector-line"></div>
                    <i class="fas fa-arrow-right"></i>
                  </div>

                  <div class="year-to">
                    <span class="year-label">To</span>
                    <span class="year-value">{{mapping.yearTo}}</span>
                  </div>
                </div>

                <div class="college-type-badge" [ngClass]="getCollegeTypeBadgeClass(mapping.collegeType)">
                  <i class="fas fa-university"></i>
                  {{mapping.collegeType}}
                </div>
              </div>
            </div>
          }
        </div>

      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<app-footer-default></app-footer-default>
